import { pushToDataLayer } from "../07-libs/gtmDataLayerPush";

/**
 * Initializes tracking of the various events that should be tracked
 * on the website.
 *
 * @returns {void}
 */
function eTrackerDataLayer() {
  trackMailto();
  trackCalendly();
  trackGoogleCalendar();
  trackContactForm();
}

/**
 * Tracks clicks on mailto links.
 *
 * It pushes an event to the data layer with the event name
 * 'mailtoClick' and the email address as the payload.
 *
 * @returns {void}
 */
function trackMailto() {
  const mailtoLinks = document.querySelectorAll("a[href^='mailto:']");
  if (!mailtoLinks.length) return;
  mailtoLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      const email = link.href.split(":")[1];
      handleDataLayerPush("mailtoClick", { email });
    });
  });
}

/**
 * Tracks clicks on links that lead to the calendly website.
 *
 * It pushes an event to the data layer with the event name
 * and parses the calendly link like
 * 'https://calendly.com/fernandez-reizwerk/30min' to extract the
 * event name 'fernandez' and pushes it as the payload.
 *
 * @returns {void}
 */
function trackCalendly() {
  const calendlyLinks = document.querySelectorAll("a[href*='calendly.com']");
  if (!calendlyLinks.length) return;
  calendlyLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      const eventName = link.href.split("/")[3];
      handleDataLayerPush("calendlyClick", { eventName });
    });
  });
}

/**
 * Tracks clicks on links that lead to the google calendar website.
 *
 * It pushes an event to the data layer with the event name
 * 'googleCalendarClick' and the page title of the page the link
 * was clicked on as the payload.
 */
function trackGoogleCalendar() {
  const googleCalendarLinks = document.querySelectorAll(
    "a[href*='calendar.google.com']"
  );
  if (!googleCalendarLinks.length) return;
  googleCalendarLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      const pageTitle = document.title;
      handleDataLayerPush("googleCalendarClick", { pageTitle });
    });
  });
}

/**
 * Tracks submit events on the contact form.
 *
 * It pushes an event to the data layer with the event name
 * 'contactFormSubmit'.
 *
 * @returns {void}
 */
function trackContactForm() {
  const contactForm = document.querySelector("form");
  if (!contactForm) return;
  contactForm.addEventListener("submit", (event) => {
    handleDataLayerPush("contactFormSubmit");
  });
}

/**
 * Pushes an event to the data layer an logs the event to the console,
 * if a cookie is found that identifies the user a TYPO3 backend user.
 *
 * @param {string} event The event name to push to the data layer.
 * @param {object} payload The payload to push to the data layer.
 * @returns {void}
 */
function handleDataLayerPush(event, payload = {}) {
  pushToDataLayer(event, payload);
  // Log the event to the console if the user is logged in
  if (document.cookie.includes("be_typo_user")) {
    console.debug("DataLayer Event: " + event, payload);
  }
}

export default eTrackerDataLayer;


